module.exports = "<div [class]=\"'holder ' + style\"\n    [ngClass]=\"{'active': state==states.activate, 'reset': state==states.reset}\"\n      (click)=\"activate()\">\n      <span>+</span>\n      <editor-pin [controlStyle]=\"controlStyle\"></editor-pin>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/editor/adder/adder.component.html
// module id = ./src/app/components/editor/adder/adder.component.html
// module chunks = main